module.exports = "/_next/static/images/ship-duotone-e62a6e5a1d3fd164484cb299fb6bf2fe.svg";